import { ORDEN_REDES, type Red } from "./redes";
import type { FirmaPdf, PerfilVendedor } from "./types";

// Campos que el vendedor edita en "Mi perfil". Las redes ya no las edita él
// (oct-2026): ver redesDeFirma().
export type DatosPerfil = Pick<
  PerfilVendedor,
  "firma_nombre" | "firma_titulo" | "firma_cargo" | "telefono" | "correo"
>;

const texto = (v: string | null | undefined) => v?.trim() || null;

// Redes de Diez Visual: fijas, las mismas en la firma de todos (oct-2026,
// pedido de Diez Visual: tantas redes por vendedor no servían).
export const REDES_EMPRESA: Red[] = [
  { red: "instagram", url: "https://www.instagram.com/diezvisual/" },
  { red: "tiktok", url: "https://www.tiktok.com/@diezvisual" },
  { red: "web", url: "https://diezvisual.ec/" },
];

// "+593 99 944 8190" -> "https://wa.me/593999448190". Un número local
// ecuatoriano (09…) se pasa a internacional. null si no parece un número.
export function enlaceWhatsapp(telefono: string | null | undefined) {
  let d = (telefono ?? "").replace(/\D/g, "");
  if (/^0\d{9}$/.test(d)) d = `593${d.slice(1)}`;
  return d.length >= 10 && d.length <= 15 ? `https://wa.me/${d}` : null;
}

// Redes de la firma: el WhatsApp del comerciante (el teléfono de su
// contacto en el CRM, el mismo al que le llega la cotización) y las de la
// empresa. Sin contacto asignado, solo las de la empresa.
export function redesDeFirma(p: Pick<PerfilVendedor, "whatsapp">): Red[] {
  const wa = enlaceWhatsapp(p.whatsapp?.telefono);
  const redes: Red[] = [
    ...REDES_EMPRESA,
    ...(wa ? [{ red: "whatsapp" as const, url: wa }] : []),
  ];
  // Mismo orden que imprime el PDF (ORDEN_REDES).
  return redes.sort(
    (a, b) => ORDEN_REDES.indexOf(a.red) - ORDEN_REDES.indexOf(b.red),
  );
}

// Firma tal como la imprime el PDF: sin nombre propio de firma se usa el
// nombre del vendedor; la sede sale de su sucursal.
export function firmaDePerfil(p: PerfilVendedor): FirmaPdf {
  return {
    titulo: texto(p.firma_titulo),
    nombre: texto(p.firma_nombre) ?? p.nombre,
    cargo: texto(p.firma_cargo),
    telefono: texto(p.telefono),
    correo: texto(p.correo),
    ciudad: p.sede?.ciudad ?? null,
    direccion: p.sede?.direccion ?? null,
    redes: redesDeFirma(p),
  };
}
